import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { safeHTML } from '../../../../utils/safeHTML';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';

const QuizItemAnswerContent = React.forwardRef(function QuizItemAnswerContent(
  { image: img, answerClick, text, note, answers, buttonId, setButtonId },
  ref,
) {
  const captionRef = useRef();
  const captionSpanRef = useRef();

  useEffect(() => {
    const caption = captionRef?.current;
    const scale = Math.min(1, caption?.clientHeight / caption?.scrollHeight);
    if (scale < 1) captionSpanRef.current.style.fontSize = `${scale}em`;
  }, []);

  return (
    <div className={classNames('quiz__item-content', 'quiz__item-content_stage-0')} ref={ref}>
      <div className={'quiz__item-block quiz__item-block_inside'}>
        {img && (
          <div className={'quiz__item-image quiz__item-image_answer'}>
            <img src={img} alt={''} />
          </div>
        )}

        <h2 className={classNames('quiz__item-title', { 'quiz__item-title_image': img })} ref={captionRef}>
          <span ref={captionSpanRef}>{safeHTML(text)}</span>
        </h2>

        <div className={`quiz__item-items`}>
          <ul>
            {answers?.map(({ text, id }, i) => (
              <li key={`li-${i}`}>
                <CustomButton
                  className={classNames('custom-button_quiz-item quiz__item-option', {
                    'quiz__item-option_yes': i === 1,
                    'quiz__item-option_no': i === 0,
                  })}
                  key={`btn-${i}`}
                  text={text}
                  disposable={true}
                  onClick={() => {
                    answerClick(id);
                    setButtonId(text.toLowerCase() === 'ложь' ? 'wrong' : 'right');
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
});

export default QuizItemAnswerContent;
QuizItemAnswerContent.propTypes = {};
